import { ChevronDown, ChevronRight } from 'react-feather'
import MemberCard from './MemberCard'
import ScoreBadge from './ScoreBadge'
import SupplierMetrics from './SupplierMetrics'

const SupplierCard = ({
  supplier,
  supplierKey,
  regionId,
  regionName,
  isExpanded,
  onToggle,
  selectedMetric,
  onSelectMetric,
  // expandedMembers,
  // toggleMemberExpansion,
  // getMemberKey,
}) => {
  return (
    <div
      className="card border-0 shadow-sm"
      data-testid={`findora-dashboard-supplier-${supplier.id}`}
    >
      <div className="card-body" style={{ backgroundColor: '#eef1f4' }}>
        <div
          className="cursor-pointer mb-3"
          onClick={onToggle}
          style={{
            cursor: supplier.members.length > 0 ? 'pointer' : 'default',
          }}
        >
          {/* DESKTOP VIEW */}
          <div className="d-none d-lg-flex align-items-center">
            {supplier.members.length > 0 &&
              (isExpanded ? (
                <ChevronDown size={16} className="me-3 text-muted" />
              ) : (
                <ChevronRight size={16} className="me-3 text-muted" />
              ))}
            <div className="me-4 flex-grow-1">
              <h6 className="mb-1 fw-semibold">{supplier.name}</h6>
              <span className="small text-muted">
                {supplier.members.length} Members
              </span>
            </div>
            <div className="d-flex align-items-center gap-3 flex-shrink-0">
              <div className="d-flex align-items-center gap-2">
                <span className="small text-muted">Onboarding</span>
                <ScoreBadge
                  score={supplier?.onboardingScore}
                  size="normal"
                />
              </div>
              <div className="d-flex align-items-center gap-2">
                <span className="small text-muted">Wage &amp; Productivity</span>
                <ScoreBadge score={supplier?.wageScore} size="normal" />
              </div>
            </div>
          </div>

          {/* MOBILE VIEW */}
          <div className="d-lg-none">
            <div className="d-flex align-items-center mb-3">
              {supplier.members.length > 0 &&
                (isExpanded ? (
                  <ChevronDown size={16} className="me-3 text-muted" />
                ) : (
                  <ChevronRight size={16} className="me-3 text-muted" />
                ))}
              <div className="flex-grow-1">
                <h6 className="mb-1 fw-semibold">{supplier.name}</h6>
                <span className="small text-muted">
                  {supplier.members.length} Members
                </span>
              </div>
            </div>

            {/* SCORES FOR MOBILE VIEW  */}
            <div className="row g-2">
              <div className="col-6">
                <div
                  className="d-flex align-items-center justify-content-center p-2 rounded"
                  style={{
                    backgroundColor: '#f0fbff',
                    border: '1px solid #e5e7eb',
                  }}
                >
                  <div className="text-center">
                    <div className="small text-muted mb-1">Onboarding</div>
                    <ScoreBadge
                      score={supplier?.onboardingScore}
                      size="normal"
                    />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div
                  className="d-flex align-items-center justify-content-center p-2 rounded"
                  style={{
                    backgroundColor: '#f0fbff',
                    border: '1px solid #e5e7eb',
                  }}
                >
                  <div className="text-center">
                    <div className="small text-muted mb-1">W&amp;P</div>
                    <ScoreBadge
                      score={supplier?.wageScore}
                      size="normal"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SUPPLIER METRICS */}
        <SupplierMetrics supplier={supplier} />

        {/* EXPANDED MEMBERS */}
        <div
          className={`collapsible-content ${isExpanded ? 'collapsible-enter-active' : 'collapsible-enter'}`}
          style={{
            maxHeight: isExpanded ? 'none' : '0',
            opacity: isExpanded ? 1 : 0,
            transform: isExpanded ? 'translateY(0)' : 'translateY(-10px)',
            overflow: isExpanded ? 'visible' : 'hidden',
            transition: isExpanded
              ? 'opacity 0.3s ease-out, transform 0.3s ease-out'
              : 'opacity 0.3s ease-in, transform 0.3s ease-in, max-height 0.3s ease-in',
          }}
        >
          {isExpanded && supplier.members && supplier.members.length > 0 && (
            <div className="pt-3 border-top border-white border-4">
              <h6 className="mb-3 text-muted">Team Members</h6>
              {(() => {
                const sortMembersAlphabetically = (members = []) => {
                  return [...members]
                    .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                    .map((member) => {
                      if (member.members && member.members.length > 0) {
                        return {
                          ...member,
                          members: sortMembersAlphabetically(member.members),
                        }
                      }
                      return member
                    })
                }

                const renderMembers = (membersToRender) => {
                  return membersToRender.map((member) => (
                    <div key={member.id || member.name}>
                      <MemberCard
                        member={member}
                        regionName={regionName}
                        supplierName={supplier.name}
                        selectedMetric={selectedMetric}
                        onSelectMetric={onSelectMetric}
                      />
                      {member.members && member.members.length > 0 && (
                        <div className="ps-4">
                          {renderMembers(member.members)}
                        </div>
                      )}
                    </div>
                  ))
                }

                const sortedMembers = sortMembersAlphabetically(
                  supplier.members,
                )
                return renderMembers(sortedMembers)
              })()}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SupplierCard
